import { AutoComplete, Input } from "antd";
import React, { useState, useEffect } from "react";

import "./stylesCustomAutoComplete.css";
import { SearchOutlined } from "@ant-design/icons";
import { AppStrings } from "../../../utils/constants/AppStrings";

function CustomAutoComplete({
  allOptions = [],
  placeholder = AppStrings.SEARCH,
  handleChange,
  clearOptions,
  selector = "game_id",
  bgColor = "transparent",
  virtual = true,
}) {
  const [options, setOptions] = useState(allOptions);

  const onSearch = (searchText) => {
    if (!searchText) {
      setOptions(allOptions);
      clearOptions();
      return;
    }

    const filteredOptions = allOptions.filter((option) =>
      option.value.toLowerCase().includes(searchText.toLowerCase())
    );

    setOptions(filteredOptions);
  };

  const onSelect = (selectedValue) => {
    const selectedGame = allOptions.find(
      (option) => option.value === selectedValue
    );

    if (selectedGame) {
      handleChange(selectedGame[selector]);
    }
  };

  useEffect(() => {
    setOptions(allOptions);
  }, [allOptions]);

  return (
    <AutoComplete
      className="custom-autocomplete"
      options={options}
      virtual={virtual}
      style={{
        width: "100%",
        background: "transparent",
      }}
      onSelect={onSelect}
      onSearch={onSearch}
      placeholder={placeholder}
    >
      <Input
        style={{
          background: bgColor,
        }}
        className="custom-autocomplete-input"
        prefix={
          <SearchOutlined style={{ fontSize: "18px", color: "#92929E" }} />
        }
      />
    </AutoComplete>
  );
}

export default CustomAutoComplete;
